import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import { useNavigate, useParams } from 'react-router-dom';
import EarnItemDetails from './EarnItemDetails';
import useEarnItems from 'hooks/useEarnItems';
import { useEffect } from 'react';
import CoinRateDetails from './CostRateDetail';
import useCoinRate from 'hooks/useCoinRate';

const CoinRateShow = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { findCoinRate, isLoading, coinRate } = useCoinRate();

	const handleEditClick = () => navigate(`/coin-rates/${id}/edit`);

	useEffect(() => {
		if (id) findCoinRate(id);
	}, [id]);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : coinRate.name}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<CoinRateDetails coinRate={coinRate} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default CoinRateShow;
